import { getProcessorsByUser, deleteQuarterlyHrRecord, postQuarterlyHr, getQuarterlyHrRecord, putQuarterlyHrRecord } from '@/api/dataentry-api-generated';
import DeleteDialog from '@/components/DeleteDialog.vue';
import SaveDialog from '@/components/SaveDialog.vue';
import { defineComponent } from '@vue/runtime-core';
export default defineComponent({
    name: 'QuartlyHumanResourceComponent',
    components: { DeleteDialog, SaveDialog },
    props: {
        propSelected: Array,
        propCreateNew: Boolean,
        propDuplicateRecord: Boolean,
        propId: String
    },
    data: function () {
        return {
            filter: '',
            effectiveDates: '',
            createNew: this.propCreateNew,
            duplicateRecord: this.propDuplicateRecord,
            id: this.propId,
            loading: false,
            processors: [],
            item: {},
            processorOptions: [{
                    label: '',
                    value: ''
                }],
            processorDisplay: {
                label: '',
                value: ''
            },
            financialYearQuarterOptions: [
                { value: 'Q1', label: 'Q1 (Jul 1 - Sep 30)' },
                { value: 'Q2', label: 'Q2 (Oct 1 - Dec 31)' },
                { value: 'Q3', label: 'Q3 (Jan 1  - Mar 31)' },
                { value: 'Q4', label: 'Q4 (Apr 1 - Jun 30)' }
            ]
        };
    },
    computed: {
        uuid() {
            return this.$route.params.uuid;
        },
        selectedItems() {
            return this.propSelected;
        },
        buttonLabel() {
            return 'SAVE';
        },
        years() {
            const currentYear = new Date().getFullYear();
            const currentDate = new Date();
            // Set the financial year start date to July 1st
            const financialYearStartDate = new Date(currentYear, 6, 1);
            // Generate values from the past 20 years until the current year
            let yearOptions = Array.from({ length: 21 }, (_, i) => `${currentYear - i} (Jul 1 ${(currentYear - i) - 1} - Jun 30 ${currentYear - i})`);
            // Add an option for the 2025 financial year if July 1st has already passed
            if (currentDate > financialYearStartDate) {
                yearOptions.unshift(`${currentYear + 1} (Jul 1 ${currentYear} - Jun 30 ${currentYear + 1})`);
            }
            return yearOptions;
        }
    },
    created() {
        this.getProcessors();
        if (!this.createNew) {
            this.getItem(this.uuid, true);
        }
        if (this.duplicateRecord) {
            if (this.id !== undefined) {
                this.getItem(this.id, false);
            }
        }
    },
    methods: {
        async getItem(uuid, isUpdate) {
            this.loading = true;
            try {
                const result = await getQuarterlyHrRecord(uuid);
                this.item = result;
                if (isUpdate) {
                    this.item.yearEntry = result.yearEntry;
                    this.processorDisplay.label = result.qrtHrProcessorLabel;
                    this.processorDisplay.value = result.processor;
                }
                else {
                    this.item.yearEntry = new Date().getFullYear();
                }
                this.loading = false;
            }
            catch (error) {
                const errMsg = error;
                if (errMsg.message.includes('ResourceNotFoundException')) {
                    this.closeDialog();
                    this.$log.addError(error);
                    this.loading = false;
                }
            }
        },
        saveItem() {
            let isVisaSplitValid = false;
            let isGenderSplitValid = false;
            // Check that the number of visa workers does not exceed the total number of staff
            if ((this.item.totalNumberOfStaff !== undefined && this.item.totalNumberOfStaff !== null) &&
                (this.item.totalNumberOf457VisaHolders !== undefined && this.item.totalNumberOf457VisaHolders !== null) &&
                (this.item.totalNumberOf482VisaHolders !== undefined && this.item.totalNumberOf482VisaHolders !== null) &&
                (this.item.totalNumberOf403VisaHolders !== undefined && this.item.totalNumberOf403VisaHolders !== null) &&
                (this.item.totalNumberOf417VisaHolders !== undefined && this.item.totalNumberOf417VisaHolders !== null) &&
                (this.item.totalNumberOfOtherVisaHolders !== undefined && this.item.totalNumberOfOtherVisaHolders !== null)) {
                const totalNumberOfVisaHolders = this.item.totalNumberOf457VisaHolders + this.item.totalNumberOf482VisaHolders + this.item.totalNumberOf403VisaHolders + this.item.totalNumberOf417VisaHolders + this.item.totalNumberOfOtherVisaHolders;
                if (this.item.totalNumberOfStaff < totalNumberOfVisaHolders) {
                    const msg = 'The number of visa holders must not exceed the total number of staff entered.';
                    const errorMsg = {
                        type: 'warning',
                        textColor: 'black',
                        timeout: 5000,
                        position: 'top',
                        message: msg,
                        html: true
                    };
                    this.$log.addCustomMessage(errorMsg);
                }
                else {
                    isVisaSplitValid = true;
                }
            }
            // Validate that the sum of the gender split fields equals the total number of staff entered
            if ((this.item.totalNumberOfStaff !== undefined && this.item.totalNumberOfStaff !== null) &&
                (this.item.totalNumberOfMales !== undefined && this.item.totalNumberOfMales !== null) &&
                (this.item.totalNumberOfFemales !== undefined && this.item.totalNumberOfFemales !== null) &&
                (this.item.totalNumberOfNonIdentified !== undefined && this.item.totalNumberOfNonIdentified !== null) &&
                (this.item.totalNumberOfUnspecified !== undefined && this.item.totalNumberOfUnspecified !== null)) {
                const totalStaffCalculated = this.item.totalNumberOfMales + this.item.totalNumberOfFemales + this.item.totalNumberOfNonIdentified + this.item.totalNumberOfUnspecified;
                if (this.item.totalNumberOfStaff !== totalStaffCalculated) {
                    const msg = 'The sum of males, females, non-identified, and unspecified staff must equal the total number of staff entered.';
                    const errorMsg = {
                        type: 'warning',
                        textColor: 'black',
                        timeout: 5000,
                        position: 'top',
                        message: msg,
                        html: true
                    };
                    this.$log.addCustomMessage(errorMsg);
                }
                else {
                    isGenderSplitValid = true;
                }
            }
            if (isVisaSplitValid && isGenderSplitValid) {
                // Save or update the item
                if (!this.createNew) {
                    this.updateItem();
                }
                else {
                    this.createItem();
                }
            }
        },
        async updateItem() {
            // Validate the form before proceeding
            const valid = await this.$refs.form.validate();
            if (valid) {
                this.loading = true;
                const req = this.item;
                try {
                    req.processor = this.processorDisplay.value;
                    await putQuarterlyHrRecord(this.uuid, this.item);
                    this.$log.addMessage('Successfully updated Quarterly Human Resource');
                    this.$router.push({ name: 'Quartile Human Resources' });
                }
                catch (error) {
                    this.$log.addError(error);
                    this.loading = false;
                }
            }
        },
        async createItem() {
            const valid = await this.$refs.form.validate();
            if (valid) {
                this.loading = true;
                const req = this.item;
                req.processor = this.processorDisplay.value;
                try {
                    await postQuarterlyHr(req);
                    this.$log.addMessage('Successfully created new Quarterly Human Resource');
                    this.$emit('refresh');
                    this.closeDialog();
                }
                catch (error) {
                    const errorObj = error;
                    if (errorObj.message.includes('ResourceAlreadyExistsException')) {
                        const uuid = errorObj.message.substring(31, errorObj.message.length);
                        const msg = `A record with the same Quarterly Human Resource already exists: <a href="#/QuarterlyHumanResource/${uuid}">VIEW</a>`;
                        const errorMsg = {
                            type: 'warning',
                            textColor: 'black',
                            timeout: 5000,
                            position: 'top',
                            message: msg,
                            html: true
                        };
                        this.$log.addCustomMessage(errorMsg);
                    }
                    else {
                        this.$log.addError(error);
                    }
                    this.loading = false;
                }
            }
        },
        async deleteItem() {
            try {
                const result = await deleteQuarterlyHrRecord(this.uuid);
                this.item = result;
                this.$log.addMessage('Successfully Deleted Quarterly Human Resource');
                this.closeDialog();
            }
            catch (error) {
                this.$log.addError(error);
            }
        },
        closeDialog() {
            if (this.createNew) {
                this.$emit('show-hide-dialog');
            }
            else {
                this.goBack();
            }
        },
        goBack() {
            this.$router.push({ name: 'Quartile Human Resources' });
        },
        async getProcessors() {
            this.loading = true;
            try {
                const result = await getProcessorsByUser({ pageSize: 1000000, deleted: false });
                this.processors = result.items;
                this.processorOptions = this.getProcessorOptions();
                this.loading = false;
            }
            catch (error) {
                this.$log.addError(error);
                this.loading = false;
            }
        },
        getProcessorOptions() {
            // Display and sort the options in alphabetical order
            return this.processors.map(i => {
                return {
                    label: i.processorLabel,
                    value: i.uuid
                };
            }).sort((a, b) => a.label.localeCompare(b.label));
        },
        filterOptions(val, update) {
            if (val === '') {
                update(() => {
                    // No filter - display default list
                    this.processorOptions = this.getProcessorOptions();
                });
                return;
            }
            update(() => {
                const needle = val.toLowerCase();
                // Sort the search results in alphabetical order
                this.processorOptions = this.getProcessorOptions()
                    .filter(v => v.label.toLowerCase().indexOf(needle) > -1)
                    .sort((a, b) => a.label.localeCompare(b.label));
            });
        }
    }
});
